export default __webpack_public_path__ + "static/media/search.f6447ca1.svg";